export const getLinkId = (title: string, link?: string): string => {
  const isExternalLink = (path: string): boolean =>
    path?.startsWith('http://') ||
    path?.startsWith('https://') ||
    path?.startsWith('//');

  if (!title) return '';

  if (link && isExternalLink(link)) {
    return title
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  return `${title
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')}${
    link
      ? `-${link
          .trim()
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^\w-]/g, '')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '')}`
      : ''
  }`;
};
